import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ListItemStyledPropT = {
  isSelected?: boolean;
};
export const getPopupContentStyle = (isMobile: boolean): React.CSSProperties =>
  ({
    width: '100%',
    maxWidth: isMobile ? 'none' : '100%',
    height: '100%',
    minHeight: 0,
    maxHeight: isMobile ? 'none' : '100%',
    padding: '0.25rem 1rem 0.75rem',
    overflow: 'hidden',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  } as React.CSSProperties);

export const ListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 0.5rem 0;
  background-color: ${({ theme }): string => theme.colors.surface};
  border: ${({ theme }): string => `${theme.borders.xs} ${theme.colors.primary.variant5}`};
  border-radius: ${({ theme }): string => theme.radius.sm};
`;

export const ListItemStyled = styled.li<ListItemStyledPropT>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.25rem 0.5rem;
  padding: 0.25rem 0 0.25rem 0.5rem;
  background: ${({ theme, isSelected }): string =>
    isSelected ? theme.colors.secondary.variant3 : theme.colors.primary.variant3};
  border-radius: ${({ theme }): string => theme.radius.xs};

  &:first-of-type {
    margin-top: 0.5rem;
  }
  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      padding: 0.75rem 0 0.75rem 0.5rem;
    }
  `}
`;

export const AttachmentNameStyled = styled(Typography)`
  max-width: 160px;
  width: 100%;
  margin-left: 6px;
  font-size: ${({ theme }): string => theme.fontSize.md};
  font-weight: ${({ theme }): string => theme.fontWeight.bold.toString()};
  color: ${({ theme }): string => theme.colors.primary.variant11};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      max-width: 200px;
    }
  `}
`;

export const DateTitleStyled = styled(Typography)`
  color: ${({ theme }): string => theme.colors.primary.variant11};
  font-size: 12px;
  font-weight: ${({ theme }): string => theme.fontWeight.bold.toString()};
`;

export const DateStyled = styled(Typography)`
  color: ${({ theme }): string => theme.colors.primary.variant11};
  font-size: 12px;
  font-weight: ${({ theme }): string => theme.fontWeight.bold.toString()};
`;

export const FlexStyled = styled(FlexContainer)`
  height: 100%;

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      height: 354px;
    }
    `}
`;
export const ApproveBtnStyled = styled(Button)`
  display: block;
  margin-left: auto;
`;
